<template>
	<div>
		<div class="bjMy1">
			<div class="message1" style="height: 250px">
				<div class="mess-img" @click="layoutClick">
					<img src="@/assets/Group 1271@2x.png" style="height: 35px; width: 35px" />
				</div>
				<div>
					<div class="message-title">用户昵称</div>
				</div>
				<div class="message-border"></div>

				<div class="user-nickname">
					<div class="flex-nickname" style="margin-left: 14px">
						<img src="../../../assets/paynec/Group 903@2x.png" style="width: 13px; height: 16px" />
						<div>
							<input placeholder="用户名称" class="inputClat" v-model="nameUser" />
						</div>
					</div>
					<div class="flex-nickname collapse-marignt" style="margin-right: 12px" @click="assetsClick">
						<div class="name-assets" style="width: 35px"></div>
						<img src="../../../assets/paynec/Group 1271@2x.png" style="margin-left: 7px; width: 16px; height: 16px" />
					</div>
				</div>
				<div class="sure-you-want" @click="wantClick">确认提交</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { memberUserUpdate } from '@/utils/api.js';

let props = defineProps(['userInfo']);
let emit = defineEmits(['membMoube']);
let nameUser = ref(props.userInfo.nickname);
const assetsClick = () => {
	nameUser.value = '';
};
const wantClick = async () => {
	let res = await memberUserUpdate({
		nickname: nameUser.value
	});
	emit('membMoube');
};
const layoutClick = () => {
	emit('membMoube');
};
</script>

<style lang="scss">
.bjMy1 {
	position: fixed;
	width: 100%;
	height: calc(100% - 70px);
	background: rgba(0, 0, 0, 0.7);
	z-index: 1000;
	bottom: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.message1 {
	width: 358px;
	height: 232px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	position: relative;
}

.mess-img {
	position: absolute;
	right: -15px;
	top: -15px;
}
.mess-img:hover{
	cursor: pointer;
}

.message-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 20px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 21px;
}
.message-border {
	width: 100%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 11px;
}

.slicess {
	padding: 0px 40px;
}
.slicess-padd {
	margin-top: 22px;
}

.title-sliceS {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.collapse-marignt{
	cursor: pointer;
}
.title-time1 {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-top: 7px;
}

.pagination-contact1 {
	position: absolute;
	bottom: 30px;
	left: 50px;
}

.user-nickname {
	width: 310px;
	height: 42px;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	margin-left: 22px;
	margin-top: 24px;
	display: flex;
}

.flex-nickname {
	display: flex;
	align-items: center;
}

.inputClat {
	border: none;
	width: 200px;
	margin-left: 5px;
	font-size: 16px;
}

.inputClat::placeholder {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #777777;
	font-style: normal;
	text-transform: none;
}

.inputClat:focus {
	outline: none;
	border: none;
}

.name-assets {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}

.sure-you-want {
	width: 310px;
	height: 52px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 52px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 32px;
	margin-left: 24px;
}

.sure-you-want:hover{
	cursor: pointer;
}
</style>
